import { useState, useEffect } from 'react'
import {
  VStack,
  Text,
  Stack,
  Button,
  Box,
  Image,
  Divider,
  useMediaQuery,
  Link,
  textDecoration
} from '@chakra-ui/react'

const quilmesImages = require.context('../../assets/images', true)

const Success = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  /* A hook that is used to store the products in the sessionStorage. */
  const [productsStorage, setProductsStorage] = useState(() => {
    const productsStorage = sessionStorage.getItem('products')

    return productsStorage ? JSON.parse(productsStorage) : []
  })

  /* Removing the products from the sessionStorage. */
  useEffect(() => {
    const objects = JSON.parse(sessionStorage.getItem('object'))
    const user = JSON.parse(sessionStorage.getItem('user'))
    const bottler = JSON.parse(sessionStorage.getItem('bottler'))
    const bottlerSelect = JSON.parse(sessionStorage.getItem('bottlerSelect'))
    const geoArea = JSON.parse(sessionStorage.getItem('geoArea'))
    const geoAreaSelect = JSON.parse(sessionStorage.getItem('geoAreaSelect'))

    /* if (objects.preferences !== undefined || objects.preferences !== null) {
      user.preferences.channel.channelId = objects.idChannel
      user.preferences.channel.description = objects.channel
    } */
    user.preferences = {
      bottler: {
        bottlerId: bottlerSelect.bottlerId,
        description: bottlerSelect.description
      },
      channel: {
        channelId: objects.idChannel,
        description: objects.channel
      },
      distributor: {
        distributorId: objects.idDistributor,
        description: objects.distributor
      },
      geoArea: {
        geoAreaId: geoAreaSelect.geoAreaId,
        description: geoAreaSelect.description
      }
    }

    sessionStorage.removeItem('products')
    sessionStorage.setItem('user', JSON.stringify(user))
  }, [productsStorage])

  return (
    <Stack alignItems={'center'} justifyContent={'center'} mx={'auto'}>
      <Box padding={4}>
        <Image
          alt='quilmes'
          h={'auto'}
          src={quilmesImages('./logo.svg')}
          w={'auto'}
        />
      </Box>
      <Divider />
      <VStack
        alignItems={'center'}
        className='success-container'
        mx='auto'
        paddingTop={12}
        w={{ base: '100%', md: '100%' }}
      >
        <Box>
          <Text
            color={'#3B3939'}
            fontWeight={400}
            textAlign={'center'}
            {...(isLargerThan768
              ? { fontSize: '32px' }
              : { fontSize: '18px' })}
          >
            ¡Listo!
          </Text>
          <Text
            color={'#3B3939'}
            fontWeight={400}
            {...(isLargerThan768
              ? { fontSize: '32px' }
              : { fontSize: '18px', textAlign: 'center' })}
          >
            Tu relevamiento se guardo con éxito
          </Text>
          <Image
            mx={'auto'}
            paddingTop={6}
            src={quilmesImages('./success.svg')}
            {...(isLargerThan768 ? { w: '50%' } : { w: '65%', marginTop: '2rem' })}
          />
          <Stack w={{ base: '100%', md: 500 }}>
            <Link _hover={{ textDecoration: 'none' }} href='/survey-information' mx={'auto'}
              textDecoration={'none'}
            >
              <Button
                colorScheme='teal'
                mx={'auto'}
                type='submit'
                variant='btn-quilmes'
                onClick={() => {
                  sessionStorage.removeItem('bottler')
                }}
                {...(isLargerThan768
                  ? { w: '100%', marginTop: '2rem' }
                  : { w: '100%', marginTop: '3rem' })}
              >
                Iniciar nuevo relevamiento
              </Button>
            </Link>
          </Stack>
        </Box>
      </VStack>
    </Stack>
  )
}

export default Success
